import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appOnlyDecimal]'
})
export class OnlyDecimalDirective {

  /**
   * keyCode's
   * 8: backspace
   * 110: signo .
   */
  constructor() { }

  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent) {
    if (
      (e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) &&
      (e.keyCode < 96 || e.keyCode > 105) &&
      (e.keyCode != 8 && e.keyCode != 110) &&
      (e.key != ',' && e.key != '.')
    ) {
      e.preventDefault();
    }
  }
}
